import React from 'react'
import { PropTypes } from 'prop-types'

import styles from './styles'

const AdminPanel = ({ candidateProfileId }) => (
  <a href={`/tara/portfolio/${candidateProfileId}/profile`} target="_blank" rel="noreferrer" className={styles.adminLink}>
    Tara candidate profile
  </a>
)

AdminPanel.propTypes = {
  candidateProfileId: PropTypes.string.isRequired,
}

export default AdminPanel
